var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d21095bc5681c85ffbdf649f64032813.js').default;export default
        Object.assign({}, scope_0 )
    